import "@mdi/font/css/materialdesignicons.css";
import { VFileUpload } from "vuetify/labs/VFileUpload";

// `vuetify/styles` carries no rules for labs components -- grep it for
// "v-file-upload" and you get nothing. VFileUpload was therefore rendering as
// unstyled markup everywhere it is used: the drop zone had no size, its bare
// fallback input showed through, and the label that turns a click into a file
// picker never covered anything, so clicking it did nothing at all. That is the
// identity upload on the profile page as well as the banner dialog.
import "vuetify/lib/labs/VFileUpload/VFileUpload.css";

import "vuetify/styles";
import { createVuetify } from "vuetify";

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components: {
      VFileUpload,
    },
    theme: {
      themes: {
        light: {
          colors: {
            primary: "#41a828",
          },
        },
      },
    },
  });
  nuxtApp.vueApp.use(vuetify);
});
